/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseConfigRecommendedSettings_ConfigFragmentDoc } from '../../../__generated__/useConfigRecommendedSettings.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplaySignalDetectionToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, signalDetection?: { __typename: 'ConfigSignalDetectionState', reported: boolean } | null, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null };

export type ConfigUpdateSignalDetectionMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateSignalDetectionInput;
}>;


export type ConfigUpdateSignalDetectionMutation = { __typename: 'Mutation', configurationUpdateSignalDetection: { __typename: 'ConfigurationModel', id: string, signalDetection?: { __typename: 'ConfigSignalDetectionState', reported: boolean } | null, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null } };

export const ConfigDisplaySignalDetectionToggle_ConfigFragmentDoc = gql`
    fragment ConfigDisplaySignalDetectionToggle_config on ConfigurationModel {
  id
  signalDetection {
    reported
  }
  ...UseConfigRecommendedSettings_config
}
    ${UseConfigRecommendedSettings_ConfigFragmentDoc}`;
export const ConfigUpdateSignalDetectionDocument = gql`
    mutation ConfigUpdateSignalDetection($input: ConfigurationUpdateSignalDetectionInput!) {
  configurationUpdateSignalDetection(input: $input) {
    id
    ...ConfigDisplaySignalDetectionToggle_config
    ...UseConfigRecommendedSettings_config
  }
}
    ${ConfigDisplaySignalDetectionToggle_ConfigFragmentDoc}
${UseConfigRecommendedSettings_ConfigFragmentDoc}`;
export type ConfigUpdateSignalDetectionMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateSignalDetectionMutation, ConfigUpdateSignalDetectionMutationVariables>;

/**
 * __useConfigUpdateSignalDetectionMutation__
 *
 * To run a mutation, you first call `useConfigUpdateSignalDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateSignalDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateSignalDetectionMutation, { data, loading, error }] = useConfigUpdateSignalDetectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateSignalDetectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateSignalDetectionMutation, ConfigUpdateSignalDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateSignalDetectionMutation, ConfigUpdateSignalDetectionMutationVariables>(ConfigUpdateSignalDetectionDocument, options);
      }
export type ConfigUpdateSignalDetectionMutationHookResult = ReturnType<typeof useConfigUpdateSignalDetectionMutation>;
export type ConfigUpdateSignalDetectionMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateSignalDetectionMutation>;
export type ConfigUpdateSignalDetectionMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateSignalDetectionMutation, ConfigUpdateSignalDetectionMutationVariables>;